import { render } from "./AuditLogsView.vue?vue&type=template&id=d9728a4c"
import script from "./AuditLogsView.vue?vue&type=script&lang=js"
export * from "./AuditLogsView.vue?vue&type=script&lang=js"

import "./AuditLogsView.vue?vue&type=style&index=0&id=d9728a4c&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__